/* eslint-disable import/prefer-default-export */
export const dark = {
  title: 'dark',

  colors: {
    primary: '#1B1F38',
    secondary: '#252A48',
    tertiary: '#313862',

    white: '#FFF',
    black: '#000',
    gray: '#363638',

    success: '#4E41F0',
    info: '#F7931B',
    warning: '#E44C4E'
  }
};
